import {
  GroupCreateRequest,
  GroupCreateResponse,
  GroupGetAllParams,
  GroupGetAllResponse,
  GroupGetResponse,
  GroupUpdateMemberRequest,
  GroupUpdateMemberResponse,
  GroupUpdateRequest,
  GroupUpdateResponse,
} from '@quromedical/models';
import { trpc } from 'trpc';

export class GroupApi {
  public async getById(id: string): Promise<GroupGetResponse> {
    const result = await trpc.client.group.getById.query({ id });

    return result;
  }

  public async getGroups(params: GroupGetAllParams): Promise<GroupGetAllResponse> {
    const result = await trpc.client.group.getAll.query(params);

    return result;
  }

  public async createGroup(group: GroupCreateRequest): Promise<GroupCreateResponse> {
    const result = await trpc.client.group.create.mutate(group);

    return result;
  }

  public async updateGroup(req: GroupUpdateRequest): Promise<GroupUpdateResponse> {
    const result = await trpc.client.group.update.mutate(req);

    return result;
  }

  public async updateGroupMembers(
    req: GroupUpdateMemberRequest
  ): Promise<GroupUpdateMemberResponse> {
    const result = await trpc.client.group.updateMembers.mutate(req);

    return result;
  }
}
